import { createStore } from 'vuex'

export default createStore({
  // strict: true,
  state: {
    league: {},
    leagueId: 1252869,
  },
  mutations: {
    setLeague(state, league) {
      state.league = league;
    },
    setLeagueId(state, leagueId) {
      state.leagueId = leagueId;
    }
  },
  actions: {
    setLeague(context, league) {
      context.commit('setLeague', league);
    },
    setLeagueId(context, leagueId) {
      context.commit('setLeagueId', leagueId);
    }
  },
  modules: {
  }
})
